import { render, staticRenderFns } from "./CompletedOrder.vue?vue&type=template&id=f3a01a9a&"
import script from "./CompletedOrder.vue?vue&type=script&lang=js&"
export * from "./CompletedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports